import {
  Actor,
  Animation,
  CollisionType,
  Keys,
  SpriteSheet,
  vec,
  Vector,
} from "excalibur";
import { Resources } from "../../Resources";
import { Config } from "../../config";
import Dialog from "../../ui/dialog";
import QuestionDialog from "../../ui/questionDialog";
import { gameState, playerState } from "../../state/stateManager";
import getNPCContent from "../../content/npcContent";
import { goToScene } from "../../main";

export default class Colin extends Actor {
  constructor(pos) {
    super({
      x: pos.x,
      y: pos.y,
      width: 32,
      height: 32,
      radius: 20,
      collisionType: CollisionType.Fixed,
      name: "colin",
    });
    this.autoMovements = [
      { type: "move", direction: "left", amount: 20 },
      { type: "move", direction: "right", amount: 20 },
    ];
    this.content = playerState.getContent();
    this.started = false;
    this.interacting = false;
    this.interactionTime = null;
    this.activeQuestion = null;
    this.cutScene = false;
  }

  onInitialize() {
    const playerSpriteSheet = SpriteSheet.fromImageSource({
      image: Resources.ColinSpriteSheet,
      grid: {
        spriteWidth: 32,
        spriteHeight: 32,
        rows: 5,
        columns: 8,
      },
    });

    const leftIdle = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(7, 3),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const rightIdle = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 2),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const upIdle = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 1),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const downIdle = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 0),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const downWalk = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(5, 0),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const upWalk = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(5, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 1),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const leftWalk = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(5, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(7, 3),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const rightWalk = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(5, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(7, 2),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    this.graphics.add("leftIdle", leftIdle);
    this.graphics.add("rightIdle", rightIdle);
    this.graphics.add("upIdle", upIdle);
    this.graphics.add("downIdle", downIdle);
    this.graphics.add("leftWalk", leftWalk);
    this.graphics.add("rightWalk", rightWalk);
    this.graphics.add("upWalk", upWalk);
    this.graphics.add("downWalk", downWalk);
    this.graphics.use("downIdle");
    const shadowSprite = playerSpriteSheet.getSprite(0, 4);
    const shadow = new Actor({ pos: new Vector(0, 0), z: 2 });
    shadow.graphics.add("shadow", shadowSprite);
    shadow.graphics.use("shadow");
    this.addChild(shadow);
  }
  onActivate() {}
  moveFunction(direction, amount) {
    console.log("cutscene: inside katie move");
    switch (direction) {
      case "left":
        this.graphics.use("leftWalk");
        this.vel = vec(-Config.GrandpaSpeed, 0);

        this.lastDir = "left";
        break;
      case "right":
        this.graphics.use("rightWalk");
        this.vel = vec(Config.GrandpaSpeed, 0);

        this.lastDir = "right";
        break;
      case "up":
        this.graphics.use("upWalk");
        this.vel = vec(0, -Config.GrandpaSpeed);

        this.lastDir = "up";
        break;
      case "down":
        this.graphics.use("downWalk");
        this.vel = vec(0, Config.GrandpaSpeed);

        this.lastDir = "down";
        break;
      default:
        break;
    }
  }
  startAuto() {
    console.log("inside startAuto");
    this.actions.repeatForever((ctx) => {
      this.started = true;
      ctx
        .callMethod(() => {
          this.graphics.use("rightWalk");
        })
        .moveTo(19 * 16, 12 * 16, 10)
        .callMethod(() => {
          this.graphics.use("downIdle");
        })

        .delay(2000)
        .callMethod(() => {
          this.graphics.use("leftWalk");
        })
        .moveTo(17 * 16, 12 * 16, 10)
        .callMethod(() => {
          this.graphics.use("downIdle");
        })
        .delay(1500);
    });
  }

  startInteraction(lastDir, player) {
    this.player = player;
    let now = new Date().getTime();
    if (this.interactionTime == null || now - this.interactionTime > 5000) {
      this.interacting = true;
      this.actions.clearActions();
      this.player.cutScene = true;
      console.log("inside startInteraction, ", lastDir);
      switch (lastDir) {
        case "left":
          this.graphics.use("rightIdle");
          break;
        case "right":
          this.graphics.use("leftIdle");
          break;
        case "up":
          this.graphics.use("downIdle");
          break;
        case "down":
          this.graphics.use("upIdle");
          break;
        default:
          break;
      }
      this.displayProperQuestion();
    } else {
      return;
    }
  }
  showDialog() {
    console.log("show dialog: question is: ", this.activeQuestion);

    this.greetingDialog = new QuestionDialog(
      [this.activeQuestion.question],
      this.activeQuestion.replies,
      (reply, replyIndex) => {
        console.log("dialog ended");
        if (this.activeQuestion.replies.length !== 0) {
          this.setRepliesToState(this.activeQuestion.relationship[replyIndex]);
        } else {
          this.setRepliesToState({ shouldShow: null });
        }
      },
      "colin",
      "top"
    );
  }
  displayProperQuestion() {
    this.questions = getNPCContent();
    console.log("displaying question, met is: ", this.content.colin.met);
    this.content = playerState.getContent();
    if (!this.content.colin.met) {
      console.log("havent met, showing first question");
      this.activeQuestion = this.questions.colin.questions.firstQuestion;
      this.content.brandAwareness = this.content.brandAwareness + 1;
      this.showDialog();
    } else {
      console.log(
        "have met, showing random,relationship is: ",
        this.content.colin.relationship
      );
      //random question based on relationship

      if (this.content.colin.relationship < 10) {
        //low level question
        console.log("have met, relationship low");
        let qu =
          this.questions.colin.randomQuestions.lowLevel[
            Math.floor(
              Math.random() *
                this.questions.colin.randomQuestions.lowLevel.length
            )
          ];
        this.activeQuestion = qu;
      } else if (10 <= this.content.colin.relationship <= 20) {
        //mid level question
        let qu =
          this.questions.colin.randomQuestions.midLevel[
            Math.floor(
              Math.random() *
                this.questions.colin.randomQuestions.midLevel.length
            )
          ];
        this.activeQuestion = qu;
      } else if (this.content.colin.relationship > 20) {
        //high level question
        let qu =
          this.questions.colin.randomQuestions.highLevel[
            Math.floor(
              Math.random() *
                this.questions.colin.randomQuestions.highLevel.length
            )
          ];
        this.activeQuestion = qu;
      }
      this.showDialog();
    }
  }
  setRepliesToState(relationshipImpact) {
    console.log(
      "inside setRepliesToState: relationshipimpact is: ",
      relationshipImpact
    );

    let content = playerState.getContent();
    if (relationshipImpact.relationshipBump) {
      content.colin.relationship =
        parseInt(content.colin.relationship) +
        parseInt(relationshipImpact.relationshipBump);
    }

    content.colin.met = true;
    this.content = content;
    if (relationshipImpact.shouldShow) {
      //should show followup dialog
      if (relationshipImpact.shouldShow == "sellHoney") {
        this.interacting = false;
        this.player.cutScene = false;
        goToScene("farmersMarketCommerce");
      } else {
        console.log(
          "shouldShow is: ",
          this.questions.colin.questions[relationshipImpact.shouldShow]
        );
        this.activeQuestion =
          this.questions.colin.questions[relationshipImpact.shouldShow];
        this.showDialog();
      }
    } else {
      this.player.cutScene = false;
      this.interacting = false;
      this.interactionTime = new Date().getTime();
      this.startAuto();
    }
  }

  onPostUpdate(engine) {
    if (!this.started && !this.cutScene) {
      this.startAuto();
    }

    if (this.interacting) {
      if (engine.input.keyboard.wasPressed(Keys.Enter)) {
        this.greetingDialog.enterPress();
      }
      if (engine.input.keyboard.wasPressed(Keys.Up)) {
        this.greetingDialog.iterateReply(true);
      }
      if (engine.input.keyboard.wasPressed(Keys.Down)) {
        this.greetingDialog.iterateReply(false);
      }
      if (engine.input.keyboard.wasPressed(Keys.X)) {
        this.interacting = false;
        this.player.cutScene = false;
        this.greetingDialog.destroy();
      }
    }
  }
}
